export default __webpack_public_path__ + "static/media/greenstar-power-bg.5cc67ce5.jpeg";